module.exports = __webpack_public_path__ + "static/media/usedsoloshow17.78a4d361.JPG";